import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "document inspection-summary p-4" }
const _hoisted_2 = { class: "grid inspection-row" }
const _hoisted_3 = { class: "col-6 doc-border" }
const _hoisted_4 = { class: "col-6 doc-border" }
const _hoisted_5 = { class: "grid inspection-row" }
const _hoisted_6 = { class: "col-6 doc-border" }
const _hoisted_7 = { class: "grid inspection-row" }
const _hoisted_8 = { class: "col-6 doc-border" }
const _hoisted_9 = { class: "grid inspection-row" }
const _hoisted_10 = { class: "col-6 doc-border" }
const _hoisted_11 = { class: "col-6 doc-border" }
const _hoisted_12 = { class: "grid inspection-row" }
const _hoisted_13 = { class: "col-6 doc-border" }
const _hoisted_14 = { class: "col-6 doc-border" }
const _hoisted_15 = { class: "grid inspection-row" }
const _hoisted_16 = { class: "col-6 doc-border" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-5" }, [
        _createElementVNode("div", { class: "grid" }, [
          _createElementVNode("div", { class: "col-8 document-title" }, [
            _createElementVNode("p", null, "BUILDING ACT 2004 "),
            _createElementVNode("p", null, " ANNUAL IQP INSPECTION SUMMARY DEFECT REPORT ")
          ]),
          _createElementVNode("div", { class: "col-4 css-image compass-logo mt-2" })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("b", null, "Building name", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.propertyData.propertyName), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("b", null, "Date", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(new Date())), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[4] || (_cache[4] = _createElementVNode("b", null, "Address", -1)),
          _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, "  " + _toDisplayString(_ctx.owner.streetAddress) + "  " + _toDisplayString(_ctx.owner.suburb) + "  " + _toDisplayString(_ctx.owner.city), 1)
        ]),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-6 doc-border" }, [
          _createElementVNode("b", null, "Inspection"),
          _createElementVNode("br"),
          _createElementVNode("span", null, "Annual BWOF renewal")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[7] || (_cache[7] = _createElementVNode("b", null, "Building Owner", -1)),
          _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.owner.companyName), 1)
        ]),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-6 doc-border" }, [
          _createElementVNode("b", null, "Defect Notice No."),
          _createElementVNode("br"),
          _createElementVNode("span")
        ], -1))
      ]),
      _cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "grid inspection-row",
        style: {"padding":"4px","min-height":"100px"}
      }, [
        _createElementVNode("div", { class: "col-12 doc-border" }, [
          _createElementVNode("b", null, "Defects:"),
          _createElementVNode("br"),
          _createElementVNode("div", {
            contenteditable: "true",
            class: "p-inputtext inspection-comment"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[10] || (_cache[10] = _createElementVNode("b", null, "Issued By: ", -1)),
          _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.bwof.issuedBy) + " - Compass New Zealand Ltd", 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[12] || (_cache[12] = _createElementVNode("b", null, "Date", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(_ctx.bwof.issuedDate)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[14] || (_cache[14] = _createElementVNode("b", null, "Signed By: ", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.bwof.issuedBy), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[16] || (_cache[16] = _createElementVNode("b", null, "Date", -1)),
          _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(_ctx.bwof.issuedDate)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-6 doc-border" }, [
          _createElementVNode("b", null, "Date Rectified"),
          _createElementVNode("br"),
          _createElementVNode("div", {
            contenteditable: "true",
            class: "p-inputtext inspection-comment"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_16, [
          _cache[18] || (_cache[18] = _createElementVNode("b", null, "Date", -1)),
          _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.formattedDate(new Date())), 1)
        ])
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("div", { class: "grid inspection-row" }, [
        _createElementVNode("div", { class: "col-6 doc-border" }, [
          _createElementVNode("b", null, "Comment"),
          _createElementVNode("br"),
          _createElementVNode("div", {
            contenteditable: "true",
            class: "p-inputtext inspection-comment"
          })
        ]),
        _createElementVNode("div", { class: "col-6 doc-border" })
      ], -1))
    ]),
    _cache[24] || (_cache[24] = _createElementVNode("div", {
      class: "document css-image compliance-schedule-defect-report-fees",
      style: {"height":"842px"}
    }, null, -1))
  ], 64))
}